import { render } from "./DefaultListSectionNewsCmp.vue?vue&type=template&id=9891c600"
import script from "./DefaultListSectionNewsCmp.vue?vue&type=script&lang=js"
export * from "./DefaultListSectionNewsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__